// The name the manual bank form locks as the account title (Bill, 2026-09-29): the
// client's legal name on file when there is one, else their first and last name.
//
// Banks open an account under the name on the ID they verified, so the legal name is
// the likelier title. A $321.5k wire to "Vlad Melnik" was rejected by an account
// titled "Vladimir Melnik", his legal name. The payments server chooses a title the
// same way when it picks one itself (a Plaid connect, the DM Override form), and its
// approval email treats a title that matches the legal name as verified.
//
// The legal name comes from the payments client record (client.legal_name, relayed
// from esodb_v2.client). "None" there means no legal name, the same as the payments
// server's legalNameOf.
export const defaultAccountTitle = (client: {
  firstName: string
  lastName: string
  legalName?: string | null
}): { name: string, isLegalName: boolean } => {
  const legal = String(client.legalName ?? "").replace(/\s+/g, " ").trim()
  if (legal && !/^(none|null|n\/a)$/i.test(legal)) return { name: legal, isLegalName: true }
  return { name: `${client.firstName} ${client.lastName}`.trim(), isLegalName: false }
}
